<template>
  <div class="login-form">
    <h1 class="center">
      <Loading v-if="isLoading"></Loading>
    </h1>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  layout: 'login',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const isLoading = ref(false);

    //로그인 api
    const autoLogin = async params => {
      isLoading.value = true;
      try {
        const result = await store.dispatch('autoLogin', params);

        if (result) {
          router.push('/managePaltform');

          /**
           * @description : store 데이터 저장
           * 1. hq 매니저 저장
           * 2. team 리스트 저장
           * 3. 템플렛 리스트 저장
           * 4. 카테고리 리스트 저장
           */
          if (store.getters.getTokenInfo) {
            store.dispatch('apiHqManagerList');
            store.dispatch('apiTemaList');
            store.dispatch('apiTemplateList');
            store.dispatch('apiFaqCategoryList');
          }
        } else {
          alert('로그인에 실패하였습니다.');
          // window.open('https://www.carrotians.net', '_self');
        }
      } catch (error) {
        alert('서버에 에러가 발생하였습니다.');
        window.open('https://www.carrotians.net', '_self');
      }

      isLoading.value = false;
    };

    onMounted(() => {
      if (Object.keys(route.query).length > 0) {
        const { email, idx } = route.query;
        autoLogin({
          email,
          idx,
        });
      } else {
        alert('당근농장을 통해서 접속해주세요.');
        window.open('https://www.carrotians.net', '_self');
      }
    });

    return {
      isLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  height: 100vh;
}

.center {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}
</style>
